module.exports = __webpack_public_path__ + "media/playing-quiz-music.79a9bdc1.mp3";